import React from 'react';

import * as S from './ProcessInfoState.styles';

export const ProcessInfoState = ({ title = '', description = '', Icon = null, status = '' }) => {
  return (
    <S.Container>
      {Icon && (
        <S.IconContainer status={status}>
          <S.IconWrapper status={status}>{Icon}</S.IconWrapper>
        </S.IconContainer>
      )}
      <S.TextWrapper description={!!description}>
        {title && <S.Title>{title}</S.Title>}
        {description && <S.Description>{description}</S.Description>}
      </S.TextWrapper>
    </S.Container>
  );
};
